import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const showThreshold = 400;

      setIsVisible(scrollPosition > showThreshold);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div>
    <section className="section section-bg-fix" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/bg/bg_4.png)' }}>
        <div className="container">
            <div className="section-header">
                <h3 className="title">News <span> letter</span></h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore </p>
            </div>
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="input-group newsletter_form">
                        <input type="email" name="#" className="form-control" autoComplete="off" placeholder="Enter Email I'd" required/>
                        <div className="input-group-append ml-0">
                            <button type="submit" className="thm-btn">Subscribe</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
         {/* <!-- Footer Start --> */}
    <footer className="section-padding thm-bg-color-two footer">
        <div className="container">
            <div className="row">
                <div className="col-lg-4 col-sm-6">
                    <div className="ft_widgets">
                        <h5 className="ft_title">About Us</h5>
                        <div className="ft_about">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                            <ul className="ft_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-2 col-sm-6">
                    <div className="ft_widgets">
                        <h5 className="ft_title">Links</h5>
                        <ul className="ft_menu">
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>
                                <Link to="/about">About</Link>
                            </li>
                            <li>
                                <Link to="/blog-grid">Blog</Link>
                            </li>
                            <li>
                                <Link to="/contact">Contact</Link>
                            </li>
                        </ul>
                    </div>
                </div>
               
                <div className="col-lg-3 col-sm-6">
                    <div className="ft_widgets">
                        <h5 className="ft_title">Contact Us</h5>
                        <ul className="ft_contact ft_menu">
                            <li>
                                <Link to="#">
                                    <i className="fas fa-phone-volume"></i>
                                    (+347) 123 456 7890
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fas fa-envelope"></i>
                                    example@example.com
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fas fa-map-marker-alt"></i>
                                    Street, 3821 Ben Street. NY 14424
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
               
                <div className="col-lg-3 col-sm-6">
                    <div className="ft_widgets">
                        <h5 className="ft_title">Recent News</h5>
                        <ul className="ft_recent_news">
                            <li>
                                <div className="thumb_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/fit2fine/assets/images/blog/small_1.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="thumb_text">
                                    <p><Link to="/blog-details">You Will Become As Off Small Your Desire.</Link></p>
                                </div>
                            </li>
                            <li>
                                <div className="thumb_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/fit2fine/assets/images/blog/small_2.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="thumb_text">
                                    <p><Link to="/blog-details">10 Tips How to Prepare Meals Fast and Easy.</Link></p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    {/* <!-- Footer End -->
    <!-- Copyright Start --> */}
    <div className="thm-bg-color-two">
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <div className="copyright">
                        <p className="mb-0">Copyright © <Link to="#" className="thm-color-one">www.example.com</Link> <span id="year"></span>. All Right Reserved</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Copyright End --> */}
    <Link to="#" data-target="html" className={`back-to-top-button ${isVisible ? 'visible' : ''}`} onClick={scrollToTop}>
        <i className="fal fa-chevron-up"></i>
    </Link>
    </div>
  )
}

export default Footer